class CustomOptions extends HTMLElement {
    constructor() {
      super();
      this.debounceTimeout = null;
    }

    connectedCallback() {
      this.inputs = Array.from(this.querySelectorAll('input'));

      this.inputs.forEach(input => input.addEventListener('input', this.inputChange.bind(this)));

      this.beforeBuy();
    }

    beforeBuy() {
      const productForm = document.querySelector('product-form form');
      if (!productForm) return;

      const submitButton = productForm.querySelector('button[type="submit"]');
      if (!submitButton) return;

      submitButton.disabled = !0;

      submitButton.addEventListener('click', (event) => {
        const result = this.checkValidate();
        if (!result) {
          event.stopPropagation();
          event.preventDefault();
        }

        event.target.disabled = !0;

        if (result) {
          event.target.disabled = !1;
        }
      });
    }

    inputChange(event) {
      event.stopPropagation();
      event.preventDefault();

      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        const optionsData = this.getJsonData();
        const currentOptionData = optionsData.find(option => option.name === input.dataset.name);
        if (!currentOptionData) return;

        if (input.value === '' && input.required) {
          this.showErrorMessage(input, 'Dies ist ein Pflichtfeld.');
          return;
        }

        if (input.value.length < currentOptionData.min) {
          this.showErrorMessage(input, `Bitte geben Sie mindestens ${currentOptionData.min} Zeichen ein.`);
          return;
        }

        if (input.value.length > currentOptionData.max) {
          this.showErrorMessage(input, `Bitte geben Sie höchstens ${currentOptionData.max} Zeichen ein.`);
          return;
        }

        this.showErrorMessage(input, '');
        const productForm = document.querySelector('product-form form');
        if (!productForm) return;

        const submitButton = productForm.querySelector('button[type="submit"]');
        if (!submitButton) return;

        submitButton.disabled = !1;
      }, 300);
    }

    checkValidate() {
      const optionsData = this.getJsonData();
      let bothIsValide = true;
      for (const input of this.inputs) {
        const currentOptionData = optionsData.find(option => option.name === input.dataset.name);
        if (!currentOptionData) {
          bothIsValide = false;
          this.showErrorMessage(input, 'Etwas ist schief gelaufen! Bitte kontaktieren Sie uns.');
          continue;
        }

        if (input.value === '' && input.required) {
          bothIsValide = false;
          this.showErrorMessage(input, 'Dies ist ein Pflichtfeld.');
          continue;
        }

        if (input.value.length < currentOptionData.min) {
          bothIsValide = false;
          this.showErrorMessage(input, `Bitte geben Sie mindestens ${currentOptionData.min} Zeichen ein.`);
          continue;
        }

        if (input.value.length > currentOptionData.max) {
          bothIsValide = false;
          this.showErrorMessage(input, `Bitte geben Sie höchstens ${currentOptionData.max} Zeichen ein.`);
        }
      }

      return bothIsValide;
    }

    showErrorMessage(elem, msg) {
      const container = elem.closest('.tpo_option-container');
      if (!container) return;

      const msgBox = container.querySelector('.tpo_error-message');
      if (!msgBox) return;

      msgBox.textContent = msg;
    }

    getJsonData() {
      const jsonData = this.querySelector('script[type="application/json"]')?.textContent;
      return jsonData ? JSON.parse(jsonData) : [];
    }
  }

  customElements.define('custom-options', CustomOptions);